import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from 'react-redux';

import Admin from "./pages/setup";
import Overview from "./pages/overview";

import HasRole from "src/utils/has-role";
import GroupMenu from "src/components/group-menu";
import GroupContainer from "src/components/group-container";

import { ArrowDownOnSquareStackIcon, CogIcon } from "@heroicons/react/24/outline";

const Layout = ({ children }) => {
  const { account: { account } } = useSelector((state) => state);

  const items = [
    { name: 'Surcharging Overview', description: 'View surcharges applied to your transactions', icon: ArrowDownOnSquareStackIcon, path: '/surcharging/overview', check: HasRole(account, ['booking-and-payment:organisation-access']) },
    { name: 'Surcharging Configuration', description: 'View and manage your surcharging configuration', icon: CogIcon, path: '/surcharging/admin', check: HasRole(account, ['booking-and-payment:organisation-access']) },
  ];

  return (
    <div id="content">
      <GroupMenu items={items} title="Surcharging" />
      <GroupContainer>
        {children}
      </GroupContainer>
    </div>
  )
};

const BasePathRenderer = () => {
  const { account: { account } } = useSelector((state) => state);

  let path = '/';

  if (HasRole(account, ['booking-and-payment:organisation-access'])) {
    path = `/surcharging/admin`;
  }

  return (
    <Route exact path="/surcharging" component={(props) => {
      return (
        <Redirect to={path} />
      )
    }}
    />
  );
};

const SettlementRouter = () => {
  const { account: { account } } = useSelector((state) => state);

  if (account?.id) {
    return (
      <React.Fragment>

        {BasePathRenderer()}

        {HasRole(account, ['booking-and-payment:organisation-access']) && (
          <Route exact path={`/surcharging/overview`} component={() => <Layout><Overview /></Layout>} />
        )}

        {HasRole(account, ['booking-and-payment:organisation-access']) && (
          <Route exact path={`/surcharging/admin`} component={() => <Layout><Admin /></Layout>} />
        )}

      </React.Fragment>
    );
  }

  return <React.Fragment />;
};

export default SettlementRouter;
